import { GridColumnVisibilityModel } from '@cbridge-utils/datagrid';
import { RuleValidity, DEFAULT_RULE_ROW_ID } from '@cbridge-tools/rules-data-grid';
import { getStatusFilterState, IRuleFilter } from '@cbridge-tools/rules-data-grid-filter';
import { IRuleManagementRowModel } from '@cbridge-packages/rule';
import { FilterMode, IPermittedRuleRowModel, IRulesManagementStore } from './rulesManagement.interface';

export const RULE_VALIDATION_DEBOUNCE = 1000;

export const DEFAULT_EMPTY_ROW_MODEL: IPermittedRuleRowModel = { id: null, index: null, profile: null };

// Synthetic read-only last row showing what applies when no rule matches. Never stored.
export const DEFAULT_RULE_ROW_MODEL: IPermittedRuleRowModel = { id: DEFAULT_RULE_ROW_ID, index: -1, profile: null, isDefault: true };

export const RULES_EDITOR_HIDDEN_COLUMNS: GridColumnVisibilityModel<IRuleManagementRowModel> = {
  status: false,
  errors: false,
  warnings: false,
  validity: false,
};

export const VALIDITY_FILTER_DEFAULT_STATE: IRuleFilter<RuleValidity> = {
  [RuleValidity.Error]: { count: 0 },
  [RuleValidity.Unused]: { count: 0 },
  [RuleValidity.Useless]: { count: 0 },
};

export const rulesManagementInitialState: IRulesManagementStore = {
  count: 0,
  filter: {
    status: getStatusFilterState(),
    validity: VALIDITY_FILTER_DEFAULT_STATE,
  },
  filterMode: FilterMode.Strict,
  editMode: false,
  invalidRules: new Set<number>(),
  isSidebarOpen: false,
};

/** Suffix of the profile setting that remembers the details sidebar state per rules page (LB-4992). */
export const RULES_SIDEBAR_OPEN_SETTING_SUFFIX = '.sidebar.open';
